import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { LineBasedGrid } from "src/types";

export function useLineBasedGridSchema(data: LineBasedGrid) {
  const { t } = useTranslation();

  return Yup.object().shape({
    distance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceBetweenPerpendicularLines"),
        })
      )
      .min(
        data.distance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceBetweenPerpendicularLines"),
          value: data.distance.minMaxDefault.min,
        })
      )
      .max(
        data.distance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceBetweenPerpendicularLines"),
          value: data.distance.minMaxDefault.max,
        })
      ),
    count: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.numberOfPointsOnPerpendicularLine"),
        })
      )
      .min(
        data.count.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.numberOfPointsOnPerpendicularLine"),
          value: data.count.minMaxDefault.min,
        })
      )
      .max(
        data.count.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.numberOfPointsOnPerpendicularLine"),
          value: data.count.minMaxDefault.max,
        })
      ),
    minDistance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceOfFirstPoint"),
        })
      )
      .min(
        data.minDistance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceOfFirstPoint"),
          value: data.minDistance.minMaxDefault.min,
        })
      )
      .max(
        data.minDistance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceOfFirstPoint"),
          value: data.minDistance.minMaxDefault.max,
        })
      ),
    maxDistance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceOfLastPoint"),
        })
      )
      .min(
        data.maxDistance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceOfLastPoint"),
          value: data.maxDistance.minMaxDefault.min,
        })
      )
      .max(
        data.maxDistance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceOfLastPoint"),
          value: data.maxDistance.minMaxDefault.max,
        })
      ),
    tolerance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.tolerance"),
        })
      )
      .min(
        data.tolerance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.tolerance"),
          value: data.tolerance.minMaxDefault.min,
        })
      )
      .max(
        data.tolerance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.tolerance"),
          value: data.tolerance.minMaxDefault.max,
        })
      ),
  });
}
